module.exports = __webpack_public_path__ + "static/img/equip4.609ca89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/equip4.png
// module id = jayP
// module chunks = 2